import { Eyebrow, Reveal } from "@/components/Reveal";

const VEHICLES = [
  {
    img: "/assets/van.jpg",
    alt: "The Kilted Courier branded van",
    unit: "Unit 01",
    name: "The Van",
    desc: "Branded, enclosed and weather-proof — parcels ride dry no matter what the mountain throws at us.",
  },
  {
    img: "/assets/ute.jpg",
    alt: "The Kilted Courier ute with trailer",
    unit: "Unit 02",
    name: "The Ute & Trailer",
    desc: "For the big, awkward and heavy stuff — furniture, hardware, and everything that won't fit in a van.",
  },
];

export default function Fleet() {
  return (
    <section id="fleet" data-testid="fleet-section" className="relative overflow-hidden py-24 sm:py-32">
      <div className="tartan-bg absolute inset-0 opacity-[0.07]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <Eyebrow>The fleet</Eyebrow>
          <h2 className="font-display mt-4 max-w-3xl text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-[#F6F1E3] sm:text-6xl">
            Real vehicles.<br />
            <span className="text-[#F0A829]">Real kilt.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2">
          {VEHICLES.map((v, i) => (
            <Reveal key={v.name} delay={i * 0.12}>
              <figure data-testid={`fleet-card-${i}`} className="group">
                <div className="relative">
                  <div className="absolute -inset-2.5 rounded-3xl border border-[#F0A829]/30 transition-colors duration-500 group-hover:border-[#F0A829]/70" />
                  <div className="clip-corner relative overflow-hidden rounded-2xl border border-white/10">
                    <img
                      src={v.img}
                      alt={v.alt}
                      data-testid={`fleet-image-${i}`}
                      className="h-72 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 sm:h-96"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0C1F17]/80 via-transparent to-transparent" />
                    <p className="font-mono-brand absolute left-5 top-5 rounded-full border border-[#F0A829]/40 bg-[#0C1F17]/80 px-3 py-1 text-[10px] uppercase tracking-[0.25em] text-[#F0A829] backdrop-blur-sm">
                      {v.unit}
                    </p>
                    <figcaption className="absolute bottom-5 left-5 right-5">
                      <p className="font-display text-3xl font-bold uppercase tracking-wide text-[#F6F1E3]">
                        {v.name}
                      </p>
                    </figcaption>
                  </div>
                </div>
                <p className="mt-5 max-w-md text-sm leading-relaxed text-[#B9C4B4]">{v.desc}</p>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
